module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2029-6e5ffb4ec1c5445b7c089f78773196ba.svg";